import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { LastAgentUpdate } from './last-agent-update-label'
import { DateTime } from '../vulnerabilities-grid/shared'

interface Result {
  readonly applicationLiveArchitecture: {
    readonly lastUpdate: DateTime
  }
}

interface Vars {
  readonly applicationID: string
  readonly organizationID: string
}

interface WrappedLastAgentUpdateProps {
  readonly applicationID: string
  readonly organizationID: string
}

export function WrappedLastAgentUpdate({
  applicationID,
  organizationID
}: WrappedLastAgentUpdateProps) {
  return (
    /* TODO probably it'd be a good idea that the endpoint supports expand for calculating only the required fields */
    <Query<Result, Vars>
      pollInterval={30000}
      query={gql`
        query ApplicationLiveArchitectureQuery(
          $organizationID: ID!
          $applicationID: ID!
        ) {
          applicationLiveArchitecture(
            organizationID: $organizationID
            applicationID: $applicationID
          ) {
            lastUpdate
          }
        }
      `}
      variables={{
        applicationID,
        organizationID
      }}
    >
      {({ loading, data }) => {
        if (loading || !data) {
          return <div />
        }

        const {
          applicationLiveArchitecture: { lastUpdate }
        } = data

        return <LastAgentUpdate date={lastUpdate} />
      }}
    </Query>
  )
}
